import React from 'react';
import Grow from '@material-ui/core/Grow';
import Popper from '@material-ui/core/Popper';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import './PopperInfo.scss';

const PopperInfo = ({id, open, anchorEl, clickAway, children, classes = ''}) => {
    return (
        <Popper
            id={id}
            open={open}
            anchorEl={anchorEl}
            transition
            placement="bottom-end"
            disablePortal
        >
            {({ TransitionProps }) => (
                <ClickAwayListener onClickAway={clickAway}>
                    <Grow {...TransitionProps} timeout={350}>
                        <div className={`popper_wrapper ${classes}`}>
                            {children}
                        </div>
                    </Grow>
                </ClickAwayListener>
            )}
        </Popper>
    );
};

export default PopperInfo;